@if (formData.formGroup) {
  <div class="input-wrapper"
       [class.no-icon]="!formData.iconLeft"
       [formGroup]="formData.formGroup">
    @if (isLoading) {
      <p-skeleton height="50px"
                  class="mb-2" />

      <label [for]="formData.id"
             class="label skeletonLabel">
        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>
    } @else {
      <textarea class="input"
                [id]="formData.id"
                [class.no-icon]="!formData.iconLeft"
                [required]="formData.required || false"
                [formControlName]="formData.id"
                [disabled]="formData.readonly || false"
                [readonly]="formData.readonly || false"
                [style.min-height.px]="formData.minHeight"
                [style.max-height.px]="formData.maxHeight"
                placeholder=""></textarea>

      <label [for]="formData.id"
             class="label">
        {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
      </label>
    }

    @if (formData.iconLeft) {
      <span class="material-symbols-rounded icon-left">
        {{ formData.iconLeft }}
      </span>
    }
  </div>
} @else if (formData.onInput) {
  <div class="input-wrapper">
    <textarea class="input"
              (input)="formData.onInput($event)"
              [id]="formData.id"
              [class.no-icon]="!formData.iconLeft"
              [formControlName]="formData.id"
              [readonly]="formData.readonly || false"
              [required]="formData.required || false"
              placeholder=""></textarea>

    <label [for]="formData.id"
           class="label">
      {{ formData.isTranslated ? (formData.label | translateSafe) : formData.label }}
    </label>

    @if (formData.iconLeft) {
      <span class="material-symbols-rounded icon-left">
        {{ formData.iconLeft }}
      </span>
    }
  </div>
}

@if (formData.required && checkError()) {
  <p class="message error">
    {{ 'common.messages.error.required' | translateSafe }}
  </p>
}

@if (!checkError() && formData.infoText) {
  <p class="message info">
    {{ formData.isTranslated ? (formData.infoText | translateSafe) : formData.infoText }}
  </p>
}
